import { FiAlertTriangle } from "react-icons/fi";

const IEP_IFSP_ACTIVE = "01";
const IEP_IFSP_CERTIFIED_AT_ENROLLMENT = "03";
const SSID_WARNING_TRIGGER_VALUES: string[] = [
  IEP_IFSP_ACTIVE,
  IEP_IFSP_CERTIFIED_AT_ENROLLMENT,
];

function shouldShowSSIDWarning(
  iepValue: string | undefined | null,
  ssidValue: string | undefined | null
): boolean {
  if (!iepValue || !SSID_WARNING_TRIGGER_VALUES.includes(iepValue)) {
    return false;
  }
  return !ssidValue || ssidValue.trim() === "";
}

export function SSIDWarning({
  iepValue,
  ssidValue,
}: {
  iepValue: string | undefined | null;
  ssidValue: string | undefined | null;
}) {
  if (!shouldShowSSIDWarning(iepValue, ssidValue)) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="d-flex align-items-start gap-1 mt-1"
      style={{ color: "#b45309", fontSize: "0.875rem", lineHeight: 1.3 }}
    >
      <FiAlertTriangle
        size={14}
        aria-hidden="true"
        style={{ flexShrink: 0, marginTop: 2 }}
      />
      <span>Child's SSID from CALPADS should be entered above</span>
    </div>
  );
}
